import { DataGrid } from '@mui/x-data-grid';
import { Button, CircularProgress, Typography } from '@mui/material';
import { useMemo } from 'react';
import { DataGridStyle } from '../../shared/sharedStyles';

export const GroupsTable = ({ lngsltd, data, handleEdit, handleDelete }) => {

    const columns = useMemo(() => {
        return [
            { field: 'id', headerName: '#', width: 150, align: 'center', headerAlign: 'center' },
            {
                field: 'groupName', headerName: lngsltd["Group Name"], width: 350, align: 'center', headerAlign: 'center',
                renderCell: (params) => (
                    <div style={{
                        width: '100%',               //  required for proper centering
                        whiteSpace: 'normal',        //  enable wrapping
                        wordBreak: 'break-word',     //  prevent overflow
                        textAlign: 'center'
                    }}>
                        {params.value}
                    </div>
                )
            },
            {
                field: 'actions',
                headerName: lngsltd["Actions"],
                flex: 1,
                align: 'center',
                headerAlign: 'center',
                renderCell: (params) => (
                    <>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleEdit(params.row.groupID)}
                            sx={{ marginRight: 1 }}
                        >
                            {lngsltd["Edit"]}
                        </Button>
                        <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() => handleDelete(params.row.groupID)}
                        >
                            {lngsltd["Delete"]}
                        </Button>
                    </>
                ),
            },
        ]
    }, []);

    const rows = data.length === 0 ? [] : data.map((d, i) => ({
        id: i + 1, // Add unique id
        groupName: d.groupName,
        groupID: d.groupID, // Keep original ID for handling actions
    }));

    if (data.length === 0) {
        return (
            <Typography variant="h6" align="center" sx={{ paddingTop: '25px' }}>
                <CircularProgress />
            </Typography>
        );
    }

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 25]}
            disableSelectionOnClick
            disableColumnResize
            getRowHeight={() => 'auto'}   //  allows row height to grow when wrapping

            sx={{
                ...DataGridStyle,

                //  Force vertical + horizontal centering for ALL cells
                '& .MuiDataGrid-cell': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }
            }}

        />
    );
}